import { User } from '@akin-home/amplify';
import { RecordWithImageFields } from '@akin-home/images';

export enum SecurityGroups {
  ADMIN = 'admins',
  WRITER = 'contentWriters',
  DEVELOPER = 'developer',
}

export interface UserModel extends User {
  id: string;
  sub: string;
  name: string;
  habitatID: string;
  email: string;
  username: string;
  securityGroups: SecurityGroups[];
  favourite_recipe_ids?: string[];
}

/** A simplified representation of a user record. */
export interface UserRef extends RecordWithImageFields {
  id: string;
  name: string;
  habitatID: string;
  profileColor?: string;
  location?: string;
}

export interface HasParticipants {
  participants?: User[];
}
